import { addDoc, collection, serverTimestamp } from "firebase/firestore"

export default class FirebaseClientLogs {
  constructor(baseDeDonnees) {
    this.baseDeDonnees = baseDeDonnees
  }

  get bdd() {
    return this.baseDeDonnees.bdd
  }

  async logErrorToFirebase(error, context = "", pseudo = "") {
    try {
      await addDoc(collection(this.bdd, "client_logs"), {
        message: error.message || error,
        stack: error.stack || "",
        context,
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: serverTimestamp(),
        pseudo,
      })
    } catch (e) {
      console.error("Impossible d'envoyer le log a Firebase", e)
    }
  }
}
